import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircle } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";

const BillingHeader = ({
  billingComplete,
  billingEditable,
  handleBillingHeaderEdit
}) => {
  return (
    <div className="checkout__step-header">
      <FontAwesomeIcon
        size="lg"
        icon={billingComplete ? faCheckCircle : faCircle}
      />
      <span className="checkout__step-number">1 of 3</span>
      <h2>Billing Information</h2>
      {billingEditable && (
        <Button
          id="billingHeaderEditButton"
          outline
          color="primary"
          size="sm"
          onClick={() => handleBillingHeaderEdit()}
        >
          Edit
        </Button>
      )}
    </div>
  );
};

export default BillingHeader;

BillingHeader.propTypes = {
  billingComplete: PropTypes.bool.isRequired,
  billingEditable: PropTypes.bool.isRequired,
  handleBillingHeaderEdit: PropTypes.func.isRequired
};
